export default "./dist/stdassets/cursors/grab.cur";